import { TextMaskModule } from 'angular2-text-mask'; // known use in several forms across site
import { ToasterModule } from 'angular2-toaster'; // known use in NotificationService
import { NgPipesModule } from 'ng-pipes';
import { FileUploadModule } from 'ng2-file-upload';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { TagInputModule } from 'ngx-chips';
import { ImageCropperModule } from 'ngx-img-cropper'; // known use in resident and profile forms
import { AutoCompleteModule } from 'primeng/autocomplete';

import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// tslint:disable-next-line:max-line-length
import { AccountFacilitiesUsageReportComponent } from './components/account-facilities-usage-report/account-facilities-usage-report.component';
import { ContentUsagePieChartComponent } from './components/content-usage-pie-chart/content-usage-pie-chart.component';
import { ContentUsageReportComponent } from './components/content-usage-report/content-usage-report.component';
import { CroppieControlComponent } from './components/croppie-control/croppie-control.component';
import { DocumentChangedByComponent } from './components/document-changed-by/document-changed-by.component';
import { DrillDownChartComponent } from './components/drill-down-chart/drill-down-chart.component';
import { DrillDownDateSelectorComponent } from './components/drill-down-date-selector/drill-down-date-selector.component';
import { ImageCropControlComponent } from './components/image-crop-control/image-crop-control.component';
import { ImagePickerControlComponent } from './components/image-picker-control/image-picker-control.component';
import { InviteFormComponent } from './components/invite-form/invite-form.component';
import { PageTitleComponent } from './components/page-title/page-title.component';
import { PanelTitleComponent } from './components/panel-title/panel-title.component';
import { SortableReportComponent } from './components/sortable-report/sortable-report.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserProfileFormComponent } from './components/user-profile-form/user-profile-form.component';
import { UserTypeSelectComponent } from './components/user-type-select/user-type-select.component';
import { UserViewComponent } from './components/user-view/user-view.component';
import { AttachmentSrcDirective } from './directives/attachment-src/attachment-src.directive';
import { DateRangeValidator } from './directives/date-range-validator/date-range-validator.directive';
import { FeatureFlagDirective } from './directives/feature-flag/feature-flag.directive';
import { FlotDirective } from './directives/flot/flot.directive';
import { RichTextEditorComponent } from './rich-text-editor/rich-text-editor.component';

// https://angular.io/styleguide#!#04-10
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FileUploadModule,
    ImageCropperModule,
    NgPipesModule,
    TextMaskModule,
    ToasterModule,
    TagInputModule,
    AccordionModule.forRoot(),
    AlertModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    AutoCompleteModule,
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
  ],
  declarations: [
    FlotDirective,
    AccountFacilitiesUsageReportComponent,
    AttachmentSrcDirective,
    DateRangeValidator,
    DocumentChangedByComponent,
    ContentUsagePieChartComponent,
    ContentUsageReportComponent,
    DrillDownChartComponent,
    DrillDownDateSelectorComponent,
    FeatureFlagDirective,
    InviteFormComponent,
    ImageCropControlComponent,
    ImagePickerControlComponent,
    CroppieControlComponent,
    PageTitleComponent,
    PanelTitleComponent,
    RichTextEditorComponent,
    SortableReportComponent,
    UserListComponent,
    UserProfileFormComponent,
    UserTypeSelectComponent,
    UserViewComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    NgPipesModule,
    TextMaskModule,
    RouterModule,
    AccordionModule,
    AlertModule,
    AutoCompleteModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    BsDatepickerModule,
    BsDropdownModule,
    ModalModule,
    PaginationModule,
    ProgressbarModule,
    RatingModule,
    TabsModule,
    TagInputModule,
    TimepickerModule,
    TooltipModule,
    TypeaheadModule,
    ToasterModule,
    FlotDirective,
    AccountFacilitiesUsageReportComponent,
    AttachmentSrcDirective,
    DateRangeValidator,
    DocumentChangedByComponent,
    ContentUsagePieChartComponent,
    ContentUsageReportComponent,
    DrillDownChartComponent,
    DrillDownDateSelectorComponent,
    FeatureFlagDirective,
    InviteFormComponent,
    ImageCropControlComponent,
    ImagePickerControlComponent,
    CroppieControlComponent,
    PageTitleComponent,
    PanelTitleComponent,
    RichTextEditorComponent,
    SortableReportComponent,
    UserListComponent,
    UserProfileFormComponent,
    UserTypeSelectComponent,
    UserViewComponent,
  ],
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
